module.exports = __webpack_public_path__ + "img/a52eedf.png";